import xhr from 'live/services/xhr'

const URL = '/services/plugin-petrobras/samter_dataserver/getpoints'

let defaultErrorCallback = function (resp, errorCallback) {
    let errorResponse = resp

    if (errorResponse.data) {
        errorResponse = errorResponse.data

        if (errorResponse.message)
            errorResponse = errorResponse.message
        else if (errorResponse.error)
            errorResponse = errorResponse.error
    } else if (errorResponse.error) { errorResponse = errorResponse.error }

    console.error(errorResponse)

    if (errorCallback)
        errorCallback(errorResponse)
}

const api = {
    get (callback, errorCallback) {
        xhr.get(URL)
            .then((resp) => {
                callback(resp.data)
            })
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },
    post (params, callback, errorCallback, finallyCallback) {
        xhr.post(URL, params)
            .then((resp) => {
                callback(resp.data)
            })
            .catch(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
            .finally(() => {
                if(finallyCallback)
                    finallyCallback()
            })
    }
}

export default api
